export interface ApiRequestSnippet {
    _comment?: string;
    data?: any;
    headers?: {
        [header: string]: string;
    };
    method: string;
    url: string;
}

export interface RequestSnippetHeaders {
    [header: string]: string;
}

export interface RequestSnippet {
    comment?: string;
    data?: any;
    headers?: RequestSnippetHeaders;
    method: string;
    url: string;
}

export function requestSnippetApiToLocal(apiSnippet: ApiRequestSnippet): RequestSnippet {
    const snippet: RequestSnippet = {
        method: apiSnippet.method,
        url: apiSnippet.url
    };

    if (apiSnippet._comment) {
        snippet.comment = apiSnippet._comment;
    }

    if (apiSnippet.data) {
        snippet.data = apiSnippet.data;
    }

    if (apiSnippet.headers) {
        snippet.headers = apiSnippet.headers;
    }

    return snippet;
}

export type RequestSnippetBuilder = (snippet: RequestSnippet) => string;

export enum SnippetLang {
    curl = 'curl',
    nodejs = 'node.js',
    python = 'python'
}

export interface RequestSnippetLang {
    name: SnippetLang;
    syntax: string;
}

export const requestSnippetLangs: Array<RequestSnippetLang> = [
    {
        name: SnippetLang.curl,
        syntax: 'bash'
    },
    {
        name: SnippetLang.python,
        syntax: 'python'
    },
    {
        name: SnippetLang.nodejs,
        syntax: 'javascript'
    }
];
